import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
    title: {
        fontSize: '12px',
        color: theme.palette.grey["900"],
        fontWeight: 500
    }
}));

export {useStyles}